import Card from "./card";
import React from "react";

export default ({ data }) => (
  <div className="flex flex-col z-10 bg-[#161a2f] w-full">
    <h1 className="title text-left mb-2 ml-2">Analysis Highlights</h1>
    {data.map((cardData) => (
      <Card data={cardData} />
    ))}
  </div>
);
